import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { itemToNameValue, NameValue } from '../key-value-card/key-value-card.component';
import { ColumnData, itemToColumnData } from '../data-table/data-table.component';
import { Subject } from 'rxjs';

interface SignificanceItem {
  valueSet: NameValue[];
}

@Component({
  selector: 'curation-therapy-match',
  templateUrl: './curation-therapy-match.component.html',
  styleUrls: ['./curation-therapy-match.component.scss']
})
export class CurationTherapyMatchComponent implements OnInit {

  @Input() set therapyMatches(v: { [key: string]: any }) {
    this._therapyMatches = v;
    if (this.configuration) {
      this.init();
    }
  }

  get therapyMatches() {
    return this._therapyMatches;
  }
  @Input() set configuration(v: { [key: string]: any }) {
    this._configuration = v;
    if (this.therapyMatches) {
      this.init();
    }
  }

  get configuration() {
    return this._configuration;
  }

  diagnostic: SignificanceItem[];
  prognostic: SignificanceItem[];
  therapeutic: SignificanceItem[];
  partialMatchTableData: ColumnData[];
  match_status: string;
  private _therapyMatches: { [key: string]: any };
  private _configuration: { [key: string]: any };

  ngOnInit(): void {
  }

  init() {
    this.match_status = this.therapyMatches[0].matchInfo.matchType;
    switch (this.match_status) {
      case 'EXACT':
        this.diagnostic = this.getSignificanceByType(this.therapyMatches[0], 'diagnostic');
        this.prognostic = this.getSignificanceByType(this.therapyMatches[0], 'prognostic');
        this.therapeutic = this.getSignificanceByType(this.therapyMatches[0], 'therapeutic');
        break;
      case 'PARTIAL':
        const counter = { row: 2 };
        this.partialMatchTableData = _.flatMap(this.therapyMatches
          .map(therapyMatch => {
            const res = { };
            res['diagnosticMaxEvidLevel'] = therapyMatch.curations[0].diagnosticMaxEvidLevel;
            res['prognosticMaxEvidLevel'] = therapyMatch.curations[0].prognosticMaxEvidLevel;
            res['therapeuticMaxEvidLevel'] = therapyMatch.curations[0].therapeuticMaxEvidLevel;
            res['tier'] = therapyMatch.curations[0].tier;
            res['matchType'] = therapyMatch.matchInfo.matchName;
            res['specific_diagnosis'] = this.getSpecificDiagnosis(therapyMatch.curations);
            res['diseaseDisplay'] = this.getCurationItem(therapyMatch.curations);
            switch (therapyMatch.curationAberration.AberrationClass) {
              case 'Fusion':
                res['gene_name'] = therapyMatch.curationAberration['gene_name1'] + '-' + therapyMatch.curationAberration['gene_name2'];
                break;
              case 'SNV':
                res['gene_name'] = therapyMatch.aberration.Target;
                break;
            }
            return res;
          })
          .map(therapyMatch => itemToColumnData(therapyMatch, this.configuration['partialMatchTableData'], counter.row++)));
        break;
    }
  }

  private getSpecificDiagnosis(curations) {
    let val = '';
    if (curations[0]) {
      const ann = curations[0].annotations.find(ann => ann.specific_diagnosis !== undefined);
      val = ann ? ann.specific_diagnosis : '';
    }
    return val;
  }

  private getCurationItem(curations) {
    return curations[0] && curations[0].curationItem && curations[0].curationItem.diseaseDisplay
      ? curations[0].curationItem.diseaseDisplay : '';
  }

  private getSignificanceByType(therapyMatch, type: string) {

    return _.flatMap(therapyMatch.curations, curation => curation.clinicalSignificances)
      .filter(clinicalSignificance => clinicalSignificance.significanceType
        && clinicalSignificance.significanceType.display === type)
      .map(clinicalSignificance => ({ valueSet: itemToNameValue(clinicalSignificance) }));
  }
}
